<div class="center-login-container">
    <div class="center-login-content">
        <!-- <img src="View/assets/images/login_logo.png"/> -->
        <img src="View/assets/images/login-logo.jpg" style="margin: 0 auto; display: block"/>
        <p-panel header="Bejelentkezés" [style]="{'padding': '0px'}">

            <p-messages [(value)]="loginErrorMessage"></p-messages>

            <table style="margin: 3px auto;" class="table-p2">
                <tbody>
                <tr>
                    <td class="form-label-normal">Felhasználónév:</td>
                    <td><input pInputText type="text" wFocusInput [(ngModel)]="username" #txtUsername
                               (keydown.enter)="usernameOnEnter($event)"/></td>
                </tr>
                <tr>
                    <td class="form-label-normal">Jelszó:</td>
                    <td><input type="password" pInputText [(ngModel)]="password" #txtPassword
                               (keydown.enter)="passwordOnEnter($event)"/></td>
                </tr><!--
        <tr>
          <td style="width: 50%" class="form-label-normal">Maradjon bejelentkezve:</td>
          <td>
            <p-checkbox binary="true" [(ngModel)]="noAutoLogout" #noLogout></p-checkbox>
          </td>
        </tr>-->
                </tbody>
            </table>

            <div class="center-content" style="margin-top: 10px;">
                <button type="button" pButton (click)="doLogin()" label="Bejelentkezés"></button>
            </div>
            <div style="border-top: #aaaaaa 1px solid; margin-top: 10px; padding-top: 5px; font-weight: bold">
                <table style="width: 100%">
                    <tr>
                        <td><a (click)="accountHandling.forgotUserPassword()" class="fake-link">Elfelejtett jelszó</a></td>
                        <td style="text-align: right;">
                            <span style="color: #0b3e6f" *ngIf="sysRole=='live'">Éles rendszer</span>
                            <span style="color: #AA0000" *ngIf="sysRole=='demo'">Demo rendszer</span>
                            <span style="color: #00AA00" *ngIf="sysRole=='test'">Teszt rendszer</span>
                        </td>
                    </tr>
                </table>
            </div>
        </p-panel>
    </div>
</div>

<account-handling #accountHandling></account-handling>


